/**
 *
 * Systems actions
 * @author Matt Shaffer, Chad Watson
 *
 *
 */
import { curry } from "ramda";
import { AppNotificationType } from "securecom-graphql/client";
import {
  CLEAR_CONNECTION_TIMEOUT,
  CONNECTION_TIMEOUT,
  RECEIVE_CAPABILITIES,
  RECEIVE_CONTROL_SYSTEMS,
  RECEIVE_INITIALIZE_SYSTEM_SESSION_ERROR,
  RECEIVE_PERMISSIONS,
  REQUEST_ALL_ZWAVE_DEVICES,
  REQUEST_CAPABILITIES,
  REQUEST_DOORS_PAGE_DATA,
  REQUEST_SYSTEM_OVERVIEW_DATA,
  SESSION_REFRESHED,
  SYSTEM_SESSION_INITIALIZED,
  TOGGLE_DEFAULT_SYSTEM,
  TOGGLE_SAVE_USER_CODE,
  USER_CODE_SUBMITTED,
} from "../constants";
import messages from "../messages";

export const receiveControlSystems = (controlSystems) => ({
  type: RECEIVE_CONTROL_SYSTEMS,
  controlSystems,
});
export const userCodeSubmitted = curry((systemId, userCode) => ({
  type: USER_CODE_SUBMITTED,
  userCode,
  systemId,
}));
export const receivePermissions = curry((systemId, permissions) => ({
  type: RECEIVE_PERMISSIONS,
  permissions,
  systemId,
}));
export const receiveInitializeSystemSessionError = (
  systemId,
  errorMessage
) => ({
  type: RECEIVE_INITIALIZE_SYSTEM_SESSION_ERROR,
  systemId,
  errorMessage,
});
export const systemSessionInitialized = ({
  systemId,
  armedStatus,
  permissions,
  capabilities,
  onDemandPanelInfo,
  now,
  systemOptions,
  isTempDealerUser,
}) => ({
  type: SYSTEM_SESSION_INITIALIZED,
  systemId,
  armedStatus,
  permissions,
  capabilities,
  onDemandPanelInfo,
  now,
  systemOptions,
  isTempDealerUser,
});
export const toggleDefaultSystem = (systemId) => ({
  type: TOGGLE_DEFAULT_SYSTEM,
  systemId,
});
export const toggleSaveUserCode = (systemId) => ({
  type: TOGGLE_SAVE_USER_CODE,
  systemId,
});
export const loadSystemCapabilities = (systemId) => ({
  type: REQUEST_CAPABILITIES,
  systemId,
});
export const receiveSystemCapabilities = (systemId, capabilities) => ({
  type: RECEIVE_CAPABILITIES,
  systemId,
  capabilities,
});
export const connectionTimeout = (systemId) => ({
  type: CONNECTION_TIMEOUT,
  systemId,
});
export const clearConnectionTimeout = (systemId) => ({
  type: CLEAR_CONNECTION_TIMEOUT,
  systemId,
});
export const requestSystemOverviewData = (systemId, availableSections) => ({
  type: REQUEST_SYSTEM_OVERVIEW_DATA,
  systemId,
  availableSections,
});
export const requestDoorsPageData = (systemId, permissions) => ({
  type: REQUEST_DOORS_PAGE_DATA,
  systemId,
  permissions,
});
export const requestAllZwaveDevices = (systemId, permissions) => ({
  type: REQUEST_ALL_ZWAVE_DEVICES,
  systemId,
  permissions,
});
export const sessionRefreshed = (systemId, now) => ({
  type: SESSION_REFRESHED,
  systemId,
  now,
});
export const slowConnectionNotification = {
  id: "SLOW_CONNECTION_MESSAGE",
  type: AppNotificationType.PROGRESS,
  message: messages.stillConnecting.defaultMessage,
};
